import { Button, Checkbox, Flex, Form, Input, Modal, Typography } from 'antd'
import { WebSitePayload } from 'src/pages/ib/adMaterials/webSitePages/types'
import { HEADWAY_PARTNERS_DOMAIN, isUrlDomainMatching } from 'src/libs/utils'

type Props = {
  initialValues: Partial<WebSitePayload>
  onSubmit: (values: WebSitePayload) => void
  loading: boolean
}

export const FormWebPage = ({ initialValues, onSubmit, loading }: Props) => {
  const { Text } = Typography
  const { Item } = Form

  const trim = (value: string) => value?.trim()
  const getRules = () => [
    {
      required: true,
      transform: trim,
      message: 'Required field',
    },
    {
      min: 3,
      transform: trim,
      message: 'Min 3 chars',
    },
  ]

  const handleFinish = (values: WebSitePayload) => {
    const payload = {
      ...values,
      title: values.title?.trim(),
      link: values.link?.trim(),
    }

    if (!isUrlDomainMatching(payload.link)) {
      Modal.confirm({
        title: 'Подтверждение',
        content: `Используется домен, отличный от ${HEADWAY_PARTNERS_DOMAIN}. Точно сохранить в таком виде?`,
        onOk: () => onSubmit(payload),
      })
      return
    }

    onSubmit(payload)
  }

  return (
    <Form
      layout="vertical"
      onFinish={handleFinish}
      initialValues={initialValues}
    >
      <Item
        label={<Text style={{ fontSize: 16 }}>Name *</Text>}
        required={false}
        name="title"
        rules={[
          ...getRules(),
          {
            max: 30,
            transform: trim,
            message: `Max 30 chars`,
          },
        ]}
      >
        <Input spellCheck={false} style={{ width: '30%' }} />
      </Item>
      <Item
        label={<Text style={{ fontSize: 16 }}>Link *</Text>}
        required={false}
        name="link"
        rules={getRules()}
      >
        <Input style={{ width: '30%' }} />
      </Item>
      <Item name="isVisible" valuePropName="checked">
        <Checkbox style={{ fontSize: 16 }}>Active</Checkbox>
      </Item>
      <Flex gap={8} justify="flex-start">
        <Button
          type="primary"
          htmlType="submit"
          loading={loading}
          style={{ width: 80 }}
        >
          Save
        </Button>
      </Flex>
    </Form>
  )
}
